import React, { useContext, useEffect, useState } from "react";
import ContextApp from "../../../core/contexts/context.app";
import ServiceStorage from "../../../core/services/service.storage";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import _ from "lodash";
import MessageBox from "./componentOrderConfirmation/MessageBox";
import ApiBasket from "../../../core/api/api.basket";

export default function OrderConfirmation() {
  const [itemData, setItemData] = useState();
  const [loadingData, setLoadingData] = useState(true);
  const params = new URLSearchParams(window.location.search);
  const ctx = useContext(ContextApp);

  useEffect(() => {
    (async () => {
      try {
        const response = await ApiBasket.getPaymentBasket({
          bid: params?.get("bid"),
        });
        response.data.basketId = params?.get("bid");
        if (!_.isEmpty(response) && response.succeeded) {
          setItemData(response.data);
          setLoadingData(false);
          // در صورت تغییر مبلغ کیف پول مبلغ کیف پول ویرایش شود
          if (
            _.isNumber(response.data.userWalletRiallBalance) &&
            response.data.userWalletRiallBalance >= 0
          ) {
            //دریافت اطلاعات کاربر
            let userInfo = ServiceStorage.getUserInfo();
            if (userInfo != null) {
              userInfo.walletRiallBalance =
                response.data.userWalletRiallBalance;
              userInfo.walletAvailableRiallBalance =
                response.data.userWalletAvailableRiallBalance;
              //ویرایش اطلاعات کاربر
              ServiceStorage.setUserInfo(userInfo);
              ctx.setUserInfo(userInfo);
            }
          }
          // در صورت پرداخت سبد ، سبد از استورج پاک شود
          if (response.data.basketId > 0) {
            await BasketHelper.deletebasket(ctx);
          }
        } else {
          setLoadingData(false);
        }
      } catch (error) {
        setLoadingData(false);
      } finally {
      }
    })();
    return () => {};
  }, []);
  /************************************ */
  return (
    <>
      {loadingData ? (
        <div className="pt-5 text-center">
          <div className="pt-5">
            {/* <DottedLoadingData withText="true" /> */} درحال دریافت اطلاعات
          </div>
        </div>
      ) : (
        <div className="mt-5 mx-auto">
          {itemData?.basketId ? (
            <>
              {/* سبد پرداخت کرده در کیف پولش به اندازه کافی موجودی داشته  این خروجی */}
              <MessageBox
                basketId={itemData.basketId}
                boxType={1}
                titleBox="عملیات موفق"
                descTitleBox="سفارش شما با موفقیت ثبت گردید."
                resultType="success"
                userPaymentId={itemData.userPaymentId}
                amount={itemData.amount}
                reserveId={itemData.reserveId}
                userWalletRiallBalance={itemData.userWalletRiallBalance}
                errorText={itemData.errorText}
              />
            </>
          ) : (
            <MessageBox
              boxType={5}
              basketId={1}
              descTitleBox="  اشکال در روند اجرا"
              titleBox="عملیات ناموفق "
              resultType="error"
            />
          )}
        </div>
      )}
    </>
  );
}
